import React, { useRef, useState , useEffect} from "react";
import { FaCloudUploadAlt } from "react-icons/fa";
import { IoIosAdd } from "react-icons/io";
import { db, storage } from "../configs/firebaseconfig";
import { doc , setDoc , collection, addDoc} from "firebase/firestore";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
export default function Form({ open, setAlert, user, setOpen}) {
  const [image, setImage] = useState("");
  const [ComInp, setComInp] = useState(["", "", "", ""]);
  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState("");
  const [imageErr, setImageErr] = useState(null);
  const [prg, setPrg] = useState(null);
  const imageRef = useRef();
  const compRef = useRef();
  useEffect(() => {
   
    if (open.item) {
     
         
          setImage(open.item.image)
          setTitle(open.item.title)
          setComInp(open.item.extendedIngredients)
          setDesc(open.item.instructions)
        }
      
   
   

  }, [open.item]);
 
function closeForm(){
  setOpen({open:false, item:null})
}
  function cahngeImage(e) {
    e.preventDefault();
    const file = imageRef.current.files[0];
    const url = URL.createObjectURL(file);
    setImage(url);
    const storageRef = ref(storage, file.name);
    const uploadTask = uploadBytesResumable(storageRef, file);
    uploadTask.on(
      "state_changed",
      (snapShot) => {
        const progress =
          (snapShot.bytesTransferred / snapShot.totalBytes) * 100;
        setPrg(progress);
      },
      (error) => {
       
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          setImage(downloadURL);
          setTimeout(() => {
            setPrg(null);
          }, 2000);
        });
      }
    );
  }
  async function addRecipe(e) {
    e.preventDefault();
    if (image === "") {
      setImageErr("please uplaod image");
    } else {
      const ComponentsCont = [...compRef.current.children];
      const Components = [];
      for (let c of ComponentsCont) {
        if (c.value !== "") {
          Components.push(c.value);
        }
      }
    
      try {
        const data= {
          chef: user.uid,
          title: title,
          image: image,
          instructions: desc,
          extendedIngredients: Components,
        }
        

        if(open.item) {
        
          await setDoc(doc(db, "recipes", open.item.id), data);
          setAlert({type:"success", ms:"recipe has been added"})
        } else {
        await addDoc(collection(db, "recipes"), data);
        setAlert({type:"success", ms:"recipe has been updated"})
        }
       
       
        
        // setAlert(
       
        closeForm();
       
       
      } catch (err) {
        setAlert({type:"error", ms:"something wrong please try again"})
      }
    }
  }

  if (!open.open) return null;
  return (
    <>
      <div className="overlay" onClick={closeForm} />
      <form className="popup form-container" onSubmit={addRecipe}>
        <div className="grid-2">
          <div
            className="form-controll img-box"
            onClick={() => imageRef.current.click()}
          >
            {image !== "" ? (
              <img src={image} alt="uploded... " />
            ) : (
              <div className="uploade-icon center">
                <FaCloudUploadAlt />
                <h4>Upload Image</h4>
              </div>
            )}
            
            {imageErr && <span >{imageErr}</span>}
            <input
              type="file"
              accept="image/*"
              ref={imageRef}
              style={{ display: "none" }}
              onChange={cahngeImage}
            />
          </div>

          <div className="info">
            <div className="form-controll">
              <label htmlFor="title">title :</label>
              <input type="text" id="title" onChange={(e)=>setTitle(e.target.value)} defaultValue={title} required />
            </div>
            <div className="form-controll">
              <label htmlFor="desc">instructions :</label>
              <textarea id="desc" onChange={(e)=>setDesc(e.target.value)} defaultValue={desc} required />
            </div>
          </div>
        </div>

        <label>Ingredients :</label>
        <div className="Components">
          <div className="grid-2" ref={compRef}>
            {ComInp.map((item) => (
              <input
                type="text"
                defaultValue={item}
                placeholder="Add Components"
              />
            ))}
          </div>
          <div
            className="center add-input"
            onClick={() => setComInp([...ComInp, ""])}
          >
            <IoIosAdd />
          </div>
        </div>
        <button
          type="button"
          disabled={prg !== null && prg < 100}
          className="btn cancle"
          onClick={closeForm}
        >
          cancle
        </button>
        <button
          type="submit"
          disabled={prg !== null && prg < 100}
          className="btn"
          
        >
          {open.item ? "Edit " : "Add "}Recipe
        </button>
        
      </form>
    </>
  );
}
